export default [
  {
    name: "Brander",
    id: 1,
    content:
      "Brander is a brand style wizard that provides users with a comprehensive set of tools to create their own brand style.",
    image:
      "https://user-images.githubusercontent.com/73825898/240259471-078f3b6c-d96e-4fe5-8f17-ca201963ffee.png",
    tech1:
      "https://img.shields.io/badge/VueJS-439A97?style=flat&logo=Vue.js&logoColor=white",
    tech2: "https://img.shields.io/badge/GPT-3.5-blue",
    tech3:
      "https://img.shields.io/badge/Django-092E20?style=flat&logo=django&logoColor=white",

    live: "https://github.com/Adrien-Nicolas/Brander",
    code: "https://github.com/Adrien-Nicolas/Brander",
  },
  {
    name: "Images Captionning",
    id: 1,
    content:
      "efficiently sort images and automatically assign a descriptive caption. Using CNNs, RNNs.",
    image:
      "https://private-user-images.githubusercontent.com/73825898/349965402-45dcbb59-7241-498e-9ee8-a938d4b62a9e.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3MjEzMDgyMDUsIm5iZiI6MTcyMTMwNzkwNSwicGF0aCI6Ii83MzgyNTg5OC8zNDk5NjU0MDItNDVkY2JiNTktNzI0MS00OThlLTllZTgtYTkzOGQ0YjYyYTllLnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNDA3MTglMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjQwNzE4VDEzMDUwNVomWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPTlkNDExMGVjNGVmMTJiMmYxMWE3MWNiNmViMjQzMTU0ZDg1OTQzZGUwZTNkNGM2M2I4ZTQyYTk2YjEyZDJjNmMmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0JmFjdG9yX2lkPTAma2V5X2lkPTAmcmVwb19pZD0wIn0.41rKMUNYYygE6mJ1fvu6VQBFt1mNSYhwn3dciZkW06I",

    live: "https://github.com/Adrien-Nicolas/Captionning_Pipeline",
    code: "https://github.com/Adrien-Nicolas/Captionning_Pipeline",
  },

  {
    name: "Metal-Detector-signal-prediction",
    id: 0,
    content:
      "Predictive model applied to a metallic soil remediation framework and using inductive detection systems",
    image:
      "https://user-images.githubusercontent.com/73825898/240250649-01f27d6e-6eac-4a6c-86cf-f4ee59185e4a.png",
    tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
    tech2:
      "https://img.shields.io/badge/scikit-learn-F7931E?style=flat&logo=scikit-learn&logoColor=white",
    live: "https://github.com/Adrien-Nicolas/Metal-Detector-signal-predicting",
    code: "https://github.com/Adrien-Nicolas/Metal-Detector-signal-predicting",
  },

  {
    name: "Robotic Computer vision",
    id: 7,
    content:
      "Implementation of computer vision inside a robotic software to detect specific shapes or specific colors. ",
    image: "https://user-images.githubusercontent.com/73825898/228518049-0c88b516-2f0d-4ade-af2f-5bf1796d5001.png",
    tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
    tech2:
      "https://img.shields.io/badge/ROS-22314E?style=flat&logo=ROS&logoColor=white",
    tech3:
      "https://img.shields.io/badge/C-00599C?style=flat&logo=c&logoColor=white",
    live: "",
    code: "",
  },
  {
    name: "auto highlights keywords subtitled",
    id: 7,
    content:
      " small testing project showcasing the possibility of creating highlights using speech-to-text and keyword research for automatic video cuts.",
    image: "https://private-user-images.githubusercontent.com/73825898/349969832-5b78d7fd-a524-473a-86a1-b4ce773b7008.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3MjEzMDg2NTksIm5iZiI6MTcyMTMwODM1OSwicGF0aCI6Ii83MzgyNTg5OC8zNDk5Njk4MzItNWI3OGQ3ZmQtYTUyNC00NzNhLTg2YTEtYjRjZTc3M2I3MDA4LnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNDA3MTglMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjQwNzE4VDEzMTIzOVomWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPTJhZWNjOGRmM2U4NDdmOWU3N2I4N2U2ZjE5MTE0NjUzZGU1ZDI4MTBlMzhjN2VlMzdiOGM4YWY1ZGI5MzJjMzEmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0JmFjdG9yX2lkPTAma2V5X2lkPTAmcmVwb19pZD0wIn0.Ul1irAnAhVqp7lQug0B8otVG8Vdo5y-r8mjHgVS2aFE",

    live: "https://github.com/Adrien-Nicolas/auto-highlights-keywords-subtitled",
    code: "https://github.com/Adrien-Nicolas/auto-highlights-keywords-subtitled",
  },
  {
    name: "Processing Points cloud from camera",
    id: 4,
    content:
      "Point-cloud manipulation is a method used for mapping and navigation in robotics, allowing robots to better understand with their surroundings.",
    image:
      "https://user-images.githubusercontent.com/73825898/228518018-eeb5d857-109a-45ba-b24a-515d3a1bda69.png",
    tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
    tech2:
      "https://img.shields.io/badge/ROS-22314E?style=flat&logo=ROS&logoColor=white",
    tech3:
      "https://img.shields.io/badge/C-00599C?style=flat&logo=c&logoColor=white",
    live: "https://github.com/Adrien-Nicolas/Point-cloud-processing-ROS",
    code: "https://github.com/Adrien-Nicolas/Point-cloud-processing-ROS",
  },
  {
    name: "Labyrinth generator",
    id: 7,
    content:
      "A labyrinth generator based on a drawn labyrinth with specific colors used. Based on computer vision and color detection.",
    image: "https://github.com/Adrien-Nicolas/labyrinth-generator/blob/main/laby_generateed.png?raw=true",
    tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
    tech2:
      "https://img.shields.io/badge/opencv-5C3EE8?style=flat&logo=opencv&logoColor=white",
    live: "https://github.com/Adrien-Nicolas/labyrinth-generator",
    code: "https://github.com/Adrien-Nicolas/labyrinth-generator",
  },
  {
    name: "Django API",
    id: 4,
    content:
      "This API aims to store user reviews about specific places like city stadiums or other sport places. ",
    image: "https://tile.jawg.io/eaf2d92b-adf6-4b93-8052-85b2063f5c44/2/1/1.png?access-token=v7aG4jlH6Xfd3rqyEDOWi3oh9RCV6byKZ972JpVE33QtqJgAB3XgW9qp4Ae5E93W",
    tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
    tech2:
      "https://img.shields.io/badge/django-092E20?style=flat&logo=django&logoColor=white",
    live: "https://github.com/Adrien-Nicolas/Django_API_public",
    code: "https://github.com/Adrien-Nicolas/Django_API_public",
  },
  {
    name: "LeoAllnet Portfolio",
    id: 0,
    content:
      "As part of a freelance mission, the artist Leoallnet gave me a project to create a portfolio to exhibit his arts.",
    image:
      "https://leoallnet.fr/img/favicon.9e88d641.png",
    tech1:
      "https://img.shields.io/badge/vue-4FC08D?style=flat&logo=vue-dot-js&logoColor=white",
    live: "https://leoallnet.fr",
    code: "https://leoallnet.fr",
  },

  {
    name: "Live camera",
    id: 4,
    content:
      "I made a surveillance camera, and a script to diffuse the camera feed on a specific and secure IP address.",
    image: "https://skills.thijs.gg/icons?i=python,raspberrypi",
    tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
    tech2:
      "https://img.shields.io/badge/raspberry-00979D?style=flat&logo=raspberry-pi&logoColor=white",
    live: "https://github.com/Adrien-Nicolas/Raspberry_camera",
    code: "https://github.com/Adrien-Nicolas/Raspberry_camera",
  },
  {
    name: "Electronics project/astronomy",
    id: 3,
    content:
      "This one, through its movement, and with the inclination equal to my latitude, allowed following the rotation of the earth.",
    image:
      "https://user-images.githubusercontent.com/73825898/171649408-0db79e62-6e50-4974-8f82-755c3d8e7a95.gif",
    tech1:
      "https://img.shields.io/badge/arduino-00979D?style=flat&logo=arduino&logoColor=white",
    live: "https://youtube.com/playlist?list=PLCMnQuXAYBkkKPMV1kw8L9sKjakr7yGWj",
    code: "https://github.com/Adrien-Nicolas/Arduino_project/tree/main/Table_eq",
  },
  {
    name: "Electronics project/Ecology",
    id: 2,
    content:
      "I wanted to build one system to monitor the environment of the plants.",
    image:
      "https://user-images.githubusercontent.com/73825898/171719487-d8c651e6-95b9-4986-99d0-2462cb5a703f.png",
    tech1:
      "https://img.shields.io/badge/arduino-00979D?style=flat&logo=arduino&logoColor=white",
    live: "https://youtube.com/playlist?list=PLCMnQuXAYBkm91QrA-oGjT1T1yhg1JD3-",
    code: "https://github.com/Adrien-Nicolas/Arduino_project/tree/main/Weather_BOX",
  },
  {
    name: "Distance sensor",
    id: 6,
    content:
      "Calculation the speed of this surface approaching the sensor to be able to estimate the time remaining before the collision and display a message alert.",
    image:
      "https://user-images.githubusercontent.com/73825898/171687028-6888728b-8624-4e28-9922-cfdfc2a8168d.png",
    tech1:
      "https://img.shields.io/badge/arduino-00979D?style=flat&logo=arduino&logoColor=white",
    live: "https://github.com/Adrien-Nicolas/Arduino_project/tree/main/Distance_capteur",
    code: "https://github.com/Adrien-Nicolas/Arduino_project/tree/main/Distance_capteur",
  },
];
